import moment from 'moment';
import { groupBy, map, toPairs, length, prop, propOr, sort, descend, ascend, equals, defaultTo, toUpper } from 'ramda';
import { isNilOrEmpty } from 'ramda-adjunct';

const MONTH_KEY_FORMAT = 'YYYY-MM';
const DAY_KEY_FORMAT = 'YYYY-MM-DD';

const groupHistoryEntriesByMonth = (entries, monthlyCounts = {}, sortDirection = 'DESC') => {
  if (isNilOrEmpty(entries)) return [];

  const normalizedSortDirection = toUpper(defaultTo('DESC', sortDirection));
  const sortByKey = key => equals('ASC', normalizedSortDirection) ? ascend(prop(key)) : descend(prop(key));
  const sortByDayKey = sortByKey('dayKey');
  const sortByMonthKey = sortByKey('monthKey');

  const byMonth = groupBy(
    entry => moment(prop('savedAt', entry)).format(MONTH_KEY_FORMAT),
    entries
  );

  const monthPairs = toPairs(byMonth);

  const monthGroups = map(([monthKey, monthEntries]) => {
    const byDay = groupBy(
      entry => moment(prop('savedAt', entry)).format(DAY_KEY_FORMAT),
      monthEntries
    );

    const dayPairs = toPairs(byDay);

    const days = map(([dayKey, dayEntries]) => ({
      dayKey,
      dayLabel: moment(dayKey, DAY_KEY_FORMAT).format('D MMMM YYYY'),
      entries: dayEntries
    }), dayPairs);

    const sortedDays = sort(sortByDayKey, days);

    return {
      monthKey,
      monthLabel: moment(monthKey, 'YYYY-MM').format('MMMM YYYY').toUpperCase(),
      entryCount: propOr(length(monthEntries), monthKey, monthlyCounts),
      days: sortedDays
    };
  }, monthPairs);

  return sort(sortByMonthKey, monthGroups);
};

export default groupHistoryEntriesByMonth;
